export default function Header() {
  return (
    <header className="w-full bg-white border-b border-gray-300 p-2 sticky top-0 z-[99999] shadow-lg">
      <div className="mx-auto flex justify-between items-center px-4 md:px-8">
        <div className="flex items-center space-x-2">
          <a href="/">
            <img
              src="/assets/jkcement-logo.png"
              alt="JK Cement Logo"
              className="h-10 sm:h-[60px]"
            />
          </a>
          {/* <span className="text-gray-600 text-lg sm:text-sm">
              Initiative of <span className="text-green-600">JKCement</span>
            </span> */}
        </div>
        <div>
          <a href="/">
            <img
              src="/assets/spsu-logo.png"
              alt="SPSU Logo"
              className="h-[auto] sm:h-[auto]"
              width={165}
            />
          </a>
        </div>
      </div>
    </header>
  );
}
